export const ROLE_GROUP = {
    ADMIN: ['admin'],
    EMPLOYEE: ['employee'],
    HR: ['hr'],
    MANAGER: ['manager', 'team leader'],
    RECRUITERS: ['recruiter'],
    WFM: ['wfm'],
};
